export function getOrCreateSessionId() {
  let sessionId = sessionStorage.getItem("session_id");
  if (!sessionId) {
    sessionId = crypto.randomUUID(); // Generate a secure ID
    sessionStorage.setItem("session_id", sessionId);
  }
  return sessionId;
}
